import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/undo.png";
import GreyIcon from "../../../../images/grey_undo.svg";

const UndoIcon = (props) => {
  var icon = Icon;
  if (!props.isUndo) {
    icon = GreyIcon;
  }
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={GreyIcon} alt="icon" />
    </Wrapper>
  );
};

export default UndoIcon;
